import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AdminComponent} from './layouts/admin/admin.component';
import {AuthComponent} from './layouts/auth/auth.component';
import {AuthGuard} from './layouts/auth/guards/auth.guard';
import {AuthService} from './layouts/auth/guards/auth.service';
import {LoginComponent} from './layouts/auth/login/login.component';


{ initialNavigation: false }

const routes: Routes = [
  
  
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: '/auth/login',
        pathMatch: 'full'
      },
      {
        path: 'portalusers',
        loadChildren: () => import('./allusers/allusers.module')
        .then(m => m.AllUsersModule), canActivate: [AuthGuard]
      },
      {
        path: 'admin',
        loadChildren: () => import('./layouts/auth/login/login.component')
        .then(m => m.LoginComponent), canActivate: [AuthGuard]
      },
      {
        path: 'edituser/:code',
        loadChildren: () => import('./allusers/edituser/edituser.module')
        .then(m => m.EditUserModule), canActivate: [AuthGuard]
      },
      {
        path: 'systemusers',
        loadChildren: () => import('./systemusers/systemusers.module')
        .then(m => m.SystemUsersModule), canActivate: [AuthGuard]
      },
      {
        path: 'allprojects',
        loadChildren: () => import('./projects/allprojects.module')
        .then(m => m.AllProjectsModule), canActivate: [AuthGuard]
      },
      {
        path: 'transactions',
        loadChildren: () => import('./transactions/transactions.module')
        .then(m => m.TransactionsModule), canActivate: [AuthGuard]
      },
      {
        path: 'editproject/:code',
        loadChildren: () => import('./projects/editproject/editproject.module')
        .then(m => m.EditProjectModule), canActivate: [AuthGuard]
      },
      {
        path: 'allroles',
        loadChildren: () => import('./roles/roles.module')
        .then(m => m.RolesModule), canActivate: [AuthGuard]
      },
      {
        path: 'changepassword',
        loadChildren: () => import('./user/changepassword/changepassword.module')
        .then(m => m.ChangePasswordModule), canActivate: [AuthGuard]
      },
      {
        path:'projectconfigurations',
        loadChildren:()=>import('./project-configurations/project-configurations.module')
        .then(m=>m.ProjectCongurationsModule),canActivate:[AuthGuard]
      },

      {
        path: 'editprojectconfigdetail/:code',
        loadChildren: () => import('./project-configurations/edit-project-config-detail/edit-project-config-detail.module')
        .then(m => m.EditProjectConfigDetailModule), canActivate: [AuthGuard]
      },
      // {
      //   path:'projectconfigurations',
      //   loadChildren:()=>import('./transactions/transactions.module')
      //   .then(m=>m.TransactionsModule),canActivate:[AuthGuard]
      // }
     
     
    ]
  },
  
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./layouts/auth/auth.module')
        .then(m => m.AuthModule)
      },
    ]
  },

  // {
  //   path: '',
  //   redirectTo: '/admin',
  //   pathMatch: 'full'

  // },

  // {
  //   path: '',
  //   component: LoginComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./layouts/auth/login/login.module')
  //       .then(m => m.LoginModule)
  //     },
  //   ]
  // },
  // { path: 'admin', component: LoginComponent },
  {
    path: '**',
    redirectTo: '/portalusers'
  },
 
];

@NgModule({
 // imports: [RouterModule.forRoot(routes, {
   // onSameUrlNavigation: 'reload'
 // })],

  imports:[  RouterModule.forRoot(routes, { useHash: true})],
 // imports: [RouterModule.forRoot(routes, { initialNavigation: true })],
  // imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard, AuthService]
})
export class AppRoutingModule { }
